export default __webpack_public_path__ + "82164fdc231fdbe1b4e24dfc17c9ac63.png";